export default "__VITE_ASSET__CLO11dTD__"